import { legacy_createStore as createStore } from 'redux'

interface IToasters {
  color: string
  message: string
  title: string
}

export type State = {
  asideShow: boolean
  sidebarShow: boolean
  theme: string
  sidebarUnfoldable: boolean
  toasters: IToasters[]
}

type Args = {
  type: string
  toast?: IToasters
  [key: string]: boolean | string | IToasters | undefined
}

const initialState: State = {
  asideShow: false,
  sidebarShow: true,
  theme: 'light',
  sidebarUnfoldable: false,
  toasters: [],
}

const changeState = (state = initialState, { type, ...rest }: Args) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    case 'setToast':
      return rest.toast ? { ...state, toasters: [...state.toasters, rest.toast] } : state
    default:
      return state
  }
}
const store = createStore(changeState)
export default store
